<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造单号</label>
            <em class="weui-form-preview__value">{{ form.main.md_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pr_code">
            <label class="weui-form-preview__label">{{customLabel.pr_code || "产品编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "产品型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_type">
            <label class="weui-form-preview__label">{{customLabel.md_type || "制造类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.md_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_qty">
            <label class="weui-form-preview__label">{{customLabel.md_qty || "数量"}}</label>
            <span class="weui-form-preview__value">
              <span>{{ form.main.md_qty }}</span>
              <!-- &nbsp;{{ form.main.pr_unit }} -->
            </span>
          </div>
          <div class="weui-form-preview__item" slot="md_havegetqty">
            <label class="weui-form-preview__label">{{customLabel.md_havegetqty || "领料数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.md_havegetqty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_turngetqty">
            <label class="weui-form-preview__label">{{customLabel.md_turngetqty || "转领料数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.md_turngetqty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_planbegindate">
            <label class="weui-form-preview__label">{{customLabel.md_planbegindate || "开工日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.md_planbegindate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_planenddate">
            <label class="weui-form-preview__label">{{customLabel.md_planenddate || "完工日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.md_planenddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_wcname">
            <label class="weui-form-preview__label">{{customLabel.md_wcname || "工作中心"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.md_wcname
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.dd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="dd_prodcode">
              <label class="weui-form-preview__label">{{customLabel.dd_prodcode || "物料编号"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.dd_prodcode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_oneuseqty">
              <label class="weui-form-preview__label">{{customLabel.dd_oneuseqty || "单位用量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.dd_oneuseqty }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="dd_qty">
              <label class="weui-form-preview__label">{{customLabel.dd_qty || "拆解数量"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_qty }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_turnqty">
              <label class="weui-form-preview__label">{{customLabel.dd_turnqty || "已转入库数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_turnqty }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_inqty">
              <label class="weui-form-preview__label">{{customLabel.dd_inqty || "完工数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_inqty }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_turnscrapqty">
              <label class="weui-form-preview__label">{{customLabel.dd_turnscrapqty || "转报废数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_turnscrapqty }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_scrapqty">
              <label class="weui-form-preview__label">{{customLabel.dd_scrapqty || "报废数"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_scrapqty }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_batchcode">
              <label class="weui-form-preview__label">{{customLabel.dd_batchcode || "批次号"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_batchcode }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_madetime">
              <label class="weui-form-preview__label">{{customLabel.dd_madetime || "生产日期"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                form.main.dd_madetime
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_shelflife">
              <label class="weui-form-preview__label">{{customLabel.dd_shelflife || "保质期（天）"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_shelflife }}</span>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dd_lifedate">
              <label class="weui-form-preview__label">{{customLabel.dd_lifedate || "保质期"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                form.main.dd_lifedate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_remark">
              <label class="weui-form-preview__label">{{customLabel.dd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">
                <span>{{ item.dd_remark }}</span>
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/production/disassemble_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/make/makeDisassemble",
      codeField: "md_code",
      statusField: "md_statuscode",
      caller: "MakeDisassemble",
      xtype: "make-makeDisassemble-formpanel",
    };
  },
};
</script>